var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatPopoverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 27.122,
    viewBox: "0 0 30 27.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.33,66.1h-17.2a3.714,3.714,0,0,0-3.705,3.7v8.51H48.17A2.188,2.188,0,0,0,46,80.522v6.925a2.188,2.188,0,0,0,2.17,2.213h1.663l.693,3.013a.722.722,0,0,0,.871.528.786.786,0,0,0,.357-.207l3.063-3.334h4.6a2.241,2.241,0,0,0,2.228-2.213V83.663h.664l5.112,5.6a.72.72,0,0,0,1.014.043.73.73,0,0,0,.214-.364l1.214-5.283h2.485A3.672,3.672,0,0,0,76,79.965V69.8A3.693,3.693,0,0,0,72.33,66.1ZM60.208,87.44a.8.8,0,0,1-.8.785H54.5a.708.708,0,0,0-.528.228l-2.356,2.57L51.1,88.782a.711.711,0,0,0-.693-.55H48.17a.756.756,0,0,1-.743-.785V80.522a.756.756,0,0,1,.743-.785h3.256v.228a3.71,3.71,0,0,0,3.705,3.7h5.076Zm14.35-7.482a2.244,2.244,0,0,1-2.228,2.27H69.275a.711.711,0,0,0-.693.55L67.547,87.3l-4.405-4.833a.708.708,0,0,0-.528-.228H55.131a2.287,2.287,0,0,1-2.277-2.27V69.8a2.278,2.278,0,0,1,2.277-2.27h17.2a2.244,2.244,0,0,1,2.228,2.27Z",
    transform: "translate(-46 -66.1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.114,148.528h8.931a.714.714,0,0,0,0-1.428h-8.931a.714.714,0,0,0,0,1.428Z",
    transform: "translate(-168.019 -141.317)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.007,210.1H178.114a.714.714,0,0,0,0,1.428h14.893a.714.714,0,1,0,0-1.428Z",
    transform: "translate(-168.019 -199.819)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPopoverIcon);
export default __webpack_public_path__ + "static/media/chat-popover-icon.1929e95e23a686a03859a1bab62a5fff.svg";
export { ForwardRef as ReactComponent };